export enum PaymentCardAuthorizationState {
    Authorized = 'Authorized',
    Expired = 'Expired',
    Failed = 'Failed',
    Pending = 'Pending',
    Requested = 'Requested',
}
